import React from 'react';
import { useParams } from 'react-router-dom';
import { Share2, Link, Twitter, Facebook, Mail } from 'lucide-react';

const ShareMenu = ({ resourceId, resourceTitle, onClose, position = "bottom" }) => {
  const { lang } = useParams();
  const currentLang = lang || 'en';
  const shareUrl = `${window.location.origin}/${currentLang}/material/${resourceId}`;
  
  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    onClose();
  };

  return (
    <div className={`absolute ${
      position === 'top' ? 'bottom-full mb-3' : 
      position === 'bottom' ? 'top-full mt-3' : ''
    } right-0 z-[100] w-56 rounded-2xl bg-card border border-border shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-1.5 animate-fade-in`}>
      <div className="px-4 py-3 border-b border-border/30 mb-1.5">
        <p className="text-[9px] font-black text-muted-foreground/40 uppercase tracking-[0.2em] leading-none mb-1">Share Resource</p>
        <p className="text-[10px] font-bold text-muted-foreground truncate max-w-full italic">{resourceTitle}</p>
      </div>
      <button onClick={handleCopy} className="w-full flex items-center gap-3.5 px-4 py-3 text-[11px] font-bold text-foreground/90 hover:bg-muted hover:text-foreground rounded-xl transition-all group/item">
        <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center text-primary group-hover/item:bg-primary group-hover/item:text-primary-foreground transition-all">
          <Link className="w-3.5 h-3.5" />
        </div>
        <span>Copy Link</span>
        <div className="ml-auto opacity-0 group-hover/item:opacity-100 transition-all -translate-x-2 group-hover/item:translate-x-0 text-[8px] text-muted-foreground/60 tracking-wider uppercase font-black">Copy</div>
      </button>
      <div className="h-px bg-border/30 my-1.5 mx-2" />
      <div className="grid grid-cols-3 gap-1.5 p-1.5">
        {[
          { icon: Twitter, color: 'hover:text-[#1DA1F2] hover:bg-[#1DA1F2]/10' },
          { icon: Facebook, color: 'hover:text-[#4267B2] hover:bg-[#4267B2]/10' },
          { icon: Mail, color: 'hover:text-primary hover:bg-primary/10' }
        ].map((social, i) => (
          <button key={i} className={`flex flex-col items-center justify-center py-4 rounded-xl transition-all group/social ${social.color} bg-border/30 active:scale-90`}>
            <social.icon className="w-4 h-4 text-muted-foreground/20 group-hover/social:text-inherit transition-colors" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ShareMenu;
